
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';

import { Line } from 'react-chartjs-2'; ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);




export default function LineChart(props) {
    return (
        <div style={{
            width: '100%', margin: 'auto', padding: '15px', height: '100%',
            boxShadow: "rgba(101, 73, 73, 0.16) 0px 1px 4px",
            borderRadius: '10px',
            backgroundColor: '#fcfcfc',

        }}>
            <Line data={props.data} options={props.options} />
        </div >
    );
}